// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getSeaConfigs as listSeaConfigAPI,
    getSeaConfig as getSeaConfigAPI,
    addSeaConfig as addSeaConfigAPI,
    updateSeaConfig as updateSeaConfigAPI,
    deleteSeaConfig as deleteSeaConfigAPI,
} from '../../helpers/';

import { seaConfigApiResponseError, seaConfigApiResponseSuccess } from './actions';
import { SeaConfigActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getSeaConfig({ payload: { id } }) {
    try {
        const response = yield call(getSeaConfigAPI, id );
        const seaConfigItem = response.data.data;
        yield put(seaConfigApiResponseSuccess(SeaConfigActionTypes.GET_SEA_CONFIG, seaConfigItem));
    } catch (error) {
        yield put(seaConfigApiResponseError(SeaConfigActionTypes.GET_SEA_CONFIG, error));
    }
}

function* addSeaConfig({payload:seaConfig}){
    try{
        const response = yield call(addSeaConfigAPI,{...seaConfig})
        const seaConfigItem = response.data
        yield put(seaConfigApiResponseSuccess(SeaConfigActionTypes.ADD_SEA_CONFIG,seaConfigItem))
    } catch(error){
        yield put(seaConfigApiResponseError(SeaConfigActionTypes.ADD_SEA_CONFIG,error))
    }
}

function* updateSeaConfig({payload:seaConfig}){
    try{
        const response = yield call(updateSeaConfigAPI,{...seaConfig})
        const seaConfigItem = response.data.data
        yield put(seaConfigApiResponseSuccess(SeaConfigActionTypes.UPDATE_SEA_CONFIG,seaConfigItem))
    }catch(error){
        yield put(seaConfigApiResponseError(SeaConfigActionTypes.UPDATE_SEA_CONFIG,error))
    }
}
function* deleteSeaConfig({payload:{id}}){
    try{
        const response = yield call(deleteSeaConfigAPI,id)
        const seaConfigItem = response.data.id
        yield put(seaConfigApiResponseSuccess(SeaConfigActionTypes.DELETE_SEA_CONFIG,seaConfigItem))
    }catch(error){
        yield put(seaConfigApiResponseError(SeaConfigActionTypes.DELETE_SEA_CONFIG,error))
    }
}

/**
 * List contactos
 */
function* listSeaConfigs({payload:params}) {
    try {
        const response = yield call(listSeaConfigAPI, { ...params });
        const listaSeaConfigs = response.data.data;
        yield put(seaConfigApiResponseSuccess(SeaConfigActionTypes.LIST_SEA_CONFIGS, listaSeaConfigs));
    } catch (error) {
        yield put(seaConfigApiResponseError(SeaConfigActionTypes.LIST_SEA_CONFIGS, error));
    }
}


export function* watchGetSeaConfig(): any {
    yield takeEvery(SeaConfigActionTypes.GET_SEA_CONFIG, getSeaConfig);
}

export function* watchListSeaConfigs(): any {
    yield takeEvery(SeaConfigActionTypes.LIST_SEA_CONFIGS, listSeaConfigs);
}

export function* watchAddSeaConfig():any{
    yield takeEvery(SeaConfigActionTypes.ADD_SEA_CONFIG,addSeaConfig)
}
export function* watchUpdateSeaConfig():any{
    yield takeEvery(SeaConfigActionTypes.UPDATE_SEA_CONFIG,updateSeaConfig)
}
export function* watchDeleteSeaConfig():any{
    yield takeEvery(SeaConfigActionTypes.DELETE_SEA_CONFIG,deleteSeaConfig)
}


function* rutasSaga(): any {
    yield all([
        fork(watchGetSeaConfig),
        fork(watchListSeaConfigs),
        fork(watchAddSeaConfig),
        fork(watchUpdateSeaConfig),
        fork(watchDeleteSeaConfig),
    ]);
}

export default rutasSaga;
